import { requirements as getRequirementsPath } from '../paths';
import { getValue } from '../selectors';
import { getDraftTariff } from '../tariff/selectors';
import { getZoneName } from '../../zone/selectors';
export var getRequirementDeps = function (state) {
    var tariff = getDraftTariff(state);
    var zoneName = getZoneName(state);
    return [zoneName, tariff];
};
export var getDraftRequirements = function (state) {
    var requirementsPath = getRequirementsPath(getRequirementDeps(state));
    return getValue(requirementsPath, state);
};
